import * as React from 'react';

const ChevronDown = (props) => (
    <svg
        {...props}
        fill='none'
        height={10}
        viewBox='0 0 20 10'
        width={20}
        xmlns='http://www.w3.org/2000/svg'>
        <path
            d='M0.585789 1.41421L8.58579 9.41421C9.36684 10.1953 10.6332 10.1953 11.4142 9.41421L19.4142 1.41421L18 -6.18172e-08L10 8L2 6.37565e-07L0.585789 1.41421Z'
            fill='currentColor'/>
    </svg>
);

export default ChevronDown;
